module.exports = __webpack_public_path__ + "static/media/manufacturers.5f1ad3e9.svg";